import { block } from '../../utils/block.js';
import { jsx } from 'react/jsx-runtime';

const b = block('modal');
const ModalHeader = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/jsx("h2", {
    className: b('title'),
    children: children
  });
};

export { ModalHeader };
